import { apiClient } from '@/api/client';
import type { UserResponse } from '@/types/shared';

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
  user: UserResponse;
}

/** POST /auth/login — 06-api-contract.md / openapi.yaml `LoginRequest` -> `AuthTokens`. */
export async function login(email: string, password: string): Promise<AuthTokens> {
  const { data } = await apiClient.post<AuthTokens>('/auth/login', { email, password });
  return data;
}

/** POST /auth/logout — revokes the presented refresh session only (that device). */
export async function logout(refreshToken: string): Promise<void> {
  await apiClient.post('/auth/logout', { refreshToken });
}

/** GET /auth/me — current authenticated user; used on app boot to validate a stored session. */
export async function me(): Promise<UserResponse> {
  const { data } = await apiClient.get<UserResponse>('/auth/me');
  return data;
}
